<sdps-notification type="information" class="sdps-m-top_none" *ngIf="!orgId">
  <p class="sdps-notification__text" [innerHTML]="getConstant.rulesConstant.ruleGlobalConst.noCientSelected"></p>
</sdps-notification>

<div *ngIf="orgId">
  <ems-manage-employees (emitData)="refreshEmpData()" (editEvent)="editModalRoute($event)" [clientName]='clientName'
                        [businessUnit]='businessUnit'></ems-manage-employees>
  <tr-edit-employee-modal [orgId]="orgId" (emitData)="refreshEmpData()"></tr-edit-employee-modal>
</div>
